import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SelectButton = styled.div`
  padding: 10px;
  font-size: 14px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background: white;
  opacity: ${props => props.disabled ? 0.5 : 1};
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const ChevronIcon = styled.i`
  font-family: FontAwesome;
  font-size: 16px;
  color: #666;
  margin-left: 8px;
  margin-right: -6px;
`;

const OptionsList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Option = styled.div`
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
  ${props => props.selected && `
    background: #e6f3ff;
  `}
`;

class CustomSelect extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        content: PropTypes.node.isRequired,
      }),
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    renderSelectedValue: PropTypes.func,
  };

  static defaultProps = {
    options: [],
    placeholder: 'Select an option',
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.selectRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.selectRef.current && !this.selectRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  toggleOpen = () => {
    if (!this.props.disabled) {
      this.setState(prev => ({ isOpen: !prev.isOpen }));
    }
  };

  handleSelect = id => {
    this.props.onChange(id);
    this.setState({ isOpen: false });
  };

  getSelectedOption() {
    return this.props.options.find(option => option.id === this.props.value);
  }

  render() {
    const selectedOption = this.getSelectedOption();

    return (
      <SelectWrapper ref={this.selectRef}>
        <SelectButton
          onClick={this.toggleOpen}
          disabled={this.props.disabled}
        >
          <ContentWrapper>
            {selectedOption ? (
              this.props.renderSelectedValue ?
                this.props.renderSelectedValue(selectedOption) :
                selectedOption.content
            ) : (
              this.props.placeholder
            )}
          </ContentWrapper>
          <ChevronIcon className='fa fa-angle-down' />
        </SelectButton>
        {this.state.isOpen && (
          <OptionsList>
            {this.props.options.map(option => (
              <Option
                key={option.id}
                onClick={() => this.handleSelect(option.id)}
                selected={option.id === this.props.value}
              >
                {option.content}
              </Option>
            ))}
          </OptionsList>
        )}
      </SelectWrapper>
    );
  }
}

export default CustomSelect;